export const refs = {
  form: document.getElementById('search-form'),
  gallery: document.querySelector('.gallery'),
  infitity: document.querySelector('.infitity-scroll'),
  body: document.querySelector('body'),
};
